var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { ref: "modal", attrs: { heading: "Send Quick Message" } },
    [
      _c("h4", [
        _vm._v(
          "Send a quick message to " + _vm._s(_vm.jobApplication.user.full_name)
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: {
            method: "POST",
            action: "/recruiter/active-requisitions/send-quick-message"
          }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "user_id" },
            domProps: { value: _vm.jobApplication.user.id }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "redirect_url" },
            domProps: { value: _vm.currentUrl }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "job_application_id" },
            domProps: { value: _vm.jobApplication.id }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mb-4" }, [
            _c("label", [_vm._v("Message")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedMessage,
                    expression: "selectedMessage"
                  }
                ],
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedMessage = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "finish_loading_your_cv" } }, [
                  _vm._v("Finish loading your CV")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "finish_your_aims_modules" } }, [
                  _vm._v("Finish your AIMS modules")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "update_your_education" } }, [
                  _vm._v("Update your Education")
                ]),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "update_your_killer_questions" } },
                  [_vm._v("Complete your Job Questionnaire")]
                ),
                _vm._v(" "),
                _c(
                  "option",
                  {
                    attrs: {
                      value: "finish_your_language_proficiency_recordings"
                    }
                  },
                  [_vm._v("Finish your Language Proficiency Recordings")]
                ),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "finish_your_skills_assessment" } },
                  [_vm._v("Finish your Skills Assessment")]
                ),
                _vm._v(" "),
                _c("option", { attrs: { value: "give_consent" } }, [
                  _vm._v("Give Consent")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "upload_your_documents" } }, [
                  _vm._v("Upload your documents")
                ])
              ]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.messages[_vm.selectedMessage]
              ? _c(
                  "textarea",
                  {
                    staticClass: "quick-message",
                    attrs: { name: "message", rows: "12" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        "Hi " +
                          _vm.jobApplication.user.full_name +
                          ".\n\n" +
                          _vm.messages[_vm.selectedMessage] +
                          "\n\nThank you.\n\nRegards,\nThe MyCalling Team"
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "subject" },
              domProps: { value: _vm.subjects[_vm.selectedMessage] }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
            _vm.messages[_vm.selectedMessage]
              ? _c("div", { staticClass: "cell shrink" }, [
                  _c(
                    "button",
                    { staticClass: "button", attrs: { type: "submit" } },
                    [_vm._v("Send")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button warning",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleModal }
                },
                [_vm._v("Close")]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7844c346", { render: render, staticRenderFns: staticRenderFns })
  }
}